const translations = {
	files: {
		empty: "Aucune pièce justificative n'a été déposée sur cette souscription.",
		legacy_empty: "Cette souscription a été reprise du prestataire. Ses pièces justificatives sont conservées dans l'historique prestataire du client.",
		open_legacy_history: "Consulter l'historique",
	},
	page_title: "Produit",
	own_by: "Société de gestion",
	new_subscription: "Lancer une nouvelle souscription",
	subscription_documents: "Documents de souscription",
	enable_electronic_signature: "Activer e-signature",
	disable_electronic_signature: "Désactiver e-signature",
	signed_documents: "Documents signés",
	back_to_products: "Retour aux produits",
	modify_data: "Modifier les données",
	modify_name: "Modifier le nom",
	add_document: "Ajouter un document",
	add_the_document: "Ajouter le document",
	deposit_document: "Déposer un document",
	no_document: "Aucun document",
	download_all_documents: "Télécharger tous les documents",
	// Private equity : dossier exporté en fin de tunnel pour la relecture de la société de gestion, avant toute signature.
	complete_dossier: {
		download: "Télécharger le dossier complet",
		file_name: "Dossier complet",
		error: "Le dossier complet n'a pas pu être généré. Réessayez dans un instant.",
	},
	trimestrial_report_history: "Historique des bulletins trimestriels",
	rename: "Renommer",
	delete_document: "Supprimer le document",
	irreverible_action: "Cette action est irréversible.",
	type: "Type",
	document_name: "Nom du document",
	data_history: "Historique des données",
	download: "Télécharger",
	documents_table: {
		name: "Nom",
		updated_at: "Date de mise à jour",
	},
	informations: {
		title: "Information de souscription",
		price: "Prix de part",
		min_number_of_shares: "Minimum de parts (à la première souscription)",
		share: "part",
		shares: "parts",
		due_date: "Délai de jouissance",
		due_date_message: "{{dueDayVar}} jour du {{dueMonthVar}} mois suivant la date de souscription",
		day: "jour",
		days: "jours",
		months: "mois",
		withdrawal_price: "Prix de retrait",
		distribution_rate: "Taux de distribution N-1",
		distribution_rate_n2: "Taux de distribution N-2",
		distribution_frequency: "Fréquence de distribution",
		financial_occupancy_rate: "Taux d'occupation financier",
		capitalization: "Capitalisation",
		retained_earnings: "Report à nouveau (jours)",
		sub_fees: "Frais de souscription",
		category: "Catégorie",
	},
	demembrement_keys: {
		title: "Démembrement - clés de répartitions :",
		duration: "Durée",
		usufruit: "Usufruit",
		nue_propriete: "Nue-propriété",
		years: "ans",
		invalid_ratio: "La somme Usufruit + Nue-propriété doit être égale à 100 % pour chaque durée.",
	},
	product_documentation_title: "Documentation produit :",
	signable_documents: {
		missing_template: {
			label: "Document manquant",
			tooltip: "Produit non digitalisé : il n'est pas encore possible de générer les documents de souscription pour ce produit.",
		},
		rto_document: "Document RTO",
	},
};

export default translations;
